import { css } from '@emotion/core';
import { variables, tokens, applyFont } from '@domain-group/fe-brary';
var font = variables.font,
  colour = variables.colour;
var colors = tokens.colors,
  typography = tokens.typography,
  spacing = tokens.spacing;
var ellipsisDetails = {
  name: "9y42th",
  styles: "width:100%;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"
};
export var container = {
  name: "4rmlxi",
  styles: "width:100%;display:flex;flex-direction:column;"
};
export var title = /*#__PURE__*/css(applyFont(typography.mini), ";color:", colors.neutral.medium.default, ";padding-top:", spacing.s, ";padding-bottom:", spacing.xs, ";");
export var features = {
  name: "5ax1kt",
  styles: "display:flex;flex-direction:row;gap:8px;"
};
export var item = /*#__PURE__*/css(applyFont(typography.bodyBold), ";display:flex;justify-content:space-between;align-items:center;background-color:", colors.neutral.background.default, ";border:1px solid ", colors.neutral.subdued.default, ";color:", colour.neutral700, ";text-decoration:none;padding:", spacing.s, " ", spacing.m, ";&:hover{background-color:", colors.neutral.background.hover, ";border:1px solid ", colors.neutral.subdued.hover, ";}");
export var itemPrice = /*#__PURE__*/css(applyFont(typography.bodyBold), ";", ellipsisDetails, " vertical-align:middle;max-width:160px;font-size:", font.baseFontSize, ";[data-new-dev-layout='three-column'] &,[data-new-dev-layout='two-column'] &{max-width:200px;}");
export var itemFeature = {
  name: "1w1orv",
  styles: "display:flex;flex-direction:row-reverse;align-items:center;gap:4px;"
};
export var itemFeatureLand = {
  name: "128dp9s",
  styles: "display:flex;flex-direction:row;align-items:baseline;gap:8px;"
};
export var itemText = /*#__PURE__*/css(applyFont(typography.miniBold));
export var itemSize = /*#__PURE__*/css(applyFont(typography.mini), " ", itemText);
export var itemIcon = /*#__PURE__*/css("width:18px;height:18px;color:", colors.neutral.heavy.default, ";");
export var itemSizeValue = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";", applyFont(typography.miniBold));
export var itemSizeValueM2 = /*#__PURE__*/css("vertical-align:super;font-size:", font.xsmallFontSize, ";");